<template>
  <div class="w-full flex flex-wrap gap-y-3">
    <Field
      :rules="(value) => requiredMinLength(value, 15) || requiredRule(value)"
      validate-on-input
      validate-on-change
      validate-on-blur
      name="identityNumber"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('identityNumber')"
        :min-length="15"
        :max-length="15"
        mask="####################"
        label-class="w-full"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        direction="flex-col"
      />
    </Field>
    <div class="w-full md:w-1/2 flex flex-col gap-y-1">
      <span>
        {{ $t('familyInformationSerial') }}
        <span class="text-brand-red">*</span>
      </span>
      <div class="flex gap-x-3">
        <Field :rules="requiredRule" name="cityNumber" v-slot="{ field, errors: errs }">
          <TextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('cityNumber')"
            :max-length="3"
            class="w-2/5"
            label-class="w-full"
            direction="flex-col"
          >
            <template #label></template>
          </TextInput>
        </Field>
        <Field :rules="requiredRule" name="familyNumber" v-slot="{ field, errors: errs }">
          <TextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('familyNumber')"
            :max-length="7"
            class="w-3/5"
            label-class="w-full"
            direction="flex-col"
          >
            <template #label></template>
          </TextInput>
        </Field>
      </div>
    </div>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

function requiredMinLength(value, length) {
  if ((value || '').length < length) {
    return i18n.t('INVALID_MIN_CHAR', [length])
  }

  return true
}

defineProps({
  dropdowns: Object
})
</script>

<style lang="scss" scoped></style>
